export const CARD_ACTIONS_TRIGGER_TEST_ID = (uuid: string) =>
  `developers_authentication_card_actions-btn-${uuid}`;
export const CARD_ACTIONS_EXPORT_OPTION_TEST_ID = (uuid: string) =>
  `developers_authentication_card_export-option-${uuid}`;
export const CARD_ACTIONS_TOGGLE_OPTION_TEST_ID = (uuid: string) =>
  `developers_authentication_card_toggle-status-option-${uuid}`;
export const TOGGLE_SCHEME_MODAL_TEST_ID =
  'developers_authentication_toggle-status-modal';
export const TOGGLE_SCHEME_CONFIRM_TEST_ID =
  'developers_authentication_toggle-status_confirm-btn';
export const TOGGLE_SCHEME_CANCEL_TEST_ID =
  'developers_authentication_toggle-status_cancel-btn';
export const TOGGLE_SCHEME_AFFECTED_ROW_TEST_ID = (uuid: string) =>
  `developers_authentication_toggle-status_affected-webhook-row-${uuid}`;
export const TOGGLE_SCHEME_IN_USE_ERROR_TEST_ID =
  'developers_authentication_toggle-status_in-use-error';
export const EXPORT_KEY_MODAL_TEST_ID =
  'developers_authentication_export-modal';
export const EXPORT_KEY_CONFIRM_TEST_ID =
  'developers_authentication_export_confirm-btn';
export const EXPORT_KEY_CANCEL_TEST_ID =
  'developers_authentication_export_cancel-btn';
export const EXPORT_KEY_COPY_TEST_ID =
  'developers_authentication_export_pem-copy-btn';
export const EXPORT_KEY_PEM_TEST_ID = 'developers_authentication_export_pem';

export const TOGGLE_MODAL_WIDTH = 480;
export const EXPORT_MODAL_WIDTH = 600;

export const EXPORT_LABEL = 'Export';
export const EXPORT_DISABLED_REASON = 'No certificate to export';
export const TOGGLE_ENABLE_LABEL = 'Enable';
export const TOGGLE_DISABLE_LABEL = 'Disable';

export const TOGGLE_SCHEME_ERROR = 'Something went wrong. Please try again.';

export const SCHEME_IN_USE_CODE = 27005;
export const SCHEME_IN_USE_ERROR =
  'This key is still used by active webhooks, so it was not disabled. Deactivate those webhooks under Developers → Webhooks, then disable the key.';

export const NO_BACKFILL_WARNING =
  'Events raised while those webhooks are inactive will not be delivered, and will not be backfilled when the webhooks are reactivated. Re-enabling this key does not reactivate them.';
export const AFFECTED_WEBHOOKS_UNKNOWN =
  'The webhooks using this key could not be loaded, so they are not listed here. Disabling it may stop webhook deliveries.';
